import React, {PureComponent} from 'react'
import {BrowserRouter, Link, Redirect, Route, Switch} from 'react-router-dom'
import {Dimmer, Loader} from 'semantic-ui-react'
import MenuBar from '../MenuBar'
import Home from '../../pages/Home'
import GettingStarted from '../../pages/GettingStarted'
import Dashboard from '../../pages/Dashboard'
import Apis from '../../pages/Apis'
import ApiDetails from '../../pages/ApiDetails'
import AlertPopup from '../../components/AlertPopup'
import {init, isAuthenticated} from '../../services/self'
import {apiGatewayClient} from '../../services/api'
import './App.css'
import SubscribeFromMarketplace from "../../shared_states/SubscriptionRequest/SubscribeFromMarketplace";

const NoMatch = () => <h2>Page not found</h2>

class MatchWhenAuthorized extends PureComponent { // eslint-disable-line
    constructor(props) {
        super(props)

        const apiGatewayClientInterval = window.setInterval(() => {
            if (apiGatewayClient) {
                window.clearInterval(apiGatewayClientInterval)
                this.setState({apiGatewayClient})
            }
        }, 100)

        this.state = {apiGatewayClient, apiGatewayClientInterval}
    }

    componentWillUnmount() {
        if (this.state.apiGatewayClientInterval) window.clearInterval(this.state.apiGatewayClientInterval)
    }

    render() {
        const {component: Component, ...rest} = this.props

        return <Route {...rest} render={props => {
            if (!isAuthenticated()) {
                return <Redirect to={{pathname: '/', state: {from: props.location}}}/>
            }

            return this.state.apiGatewayClient ? <Component {...props} /> : (<Dimmer active>
                <Loader content='Loading'/>
            </Dimmer>)
        }}/>
    }
}

export default class App extends PureComponent {
    constructor() {
        super();
        init();

        // We are using an S3 redirect rule to prefix the url path with #!
        // This then converts it back to a URL path for React routing
        // NOTE: For local development, you will get a Page Not Found when refreshing the Swagger UI page when it has a #!
        const hashRoute = location.hash.substring(2)
        history.pushState({}, 'home page', hashRoute)
    }

    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <div className="App-header">
                        <Link to="/"><h1>envimation</h1></Link>
                        <hr/>
                        <h2>Environment Automation Delivered to You</h2>
                        <span className="App-sub-header">powered by </span><a href="https://www.envimate.com"
                                                                              target="_blank">envimate GmbH</a>
                        <MenuBar/>
                    </div>
                    <section className="App-intro">
                        <AlertPopup/>
                        <Switch>
                            <Route exact path="/" component={Home}/>
                            <Route exact path="/subscribeFromMarketplace/:token"
                                   component={SubscribeFromMarketplace}/>
                            <Route exact path="/register" render={props => {
                                return <Home registerOpened={true}/>
                            }}/>
                            <Route path="/getting-started" component={GettingStarted}/>
                            <Route path="/dashboard" component={Dashboard}/>
                            <Route exact path="/apis" component={Apis}/>
                            <Route path="/apis/:apiId" component={ApiDetails}/>
                            <Route component={NoMatch}/>
                        </Switch>
                    </section>
                    <div className="App-footer">
                        <span className="App-sub-footer"><a href="https://envimate.com/#contact" target="_blank">Contact Us</a></span>
                        <span className="App-sub-footer"><a href="https://www.envimation.com/PrivacyPolicy.html" target="_blank">Privacy Policy</a></span>
                        <span className="App-sub-footer"><a href="https://envimate.com/impressum/" target="_blank">Impressum</a></span>
                        <span className="App-sub-footer"><a href="https://blog.envimate.com/" target="_blank">Blog</a></span>
                    </div>
                </div>
            </BrowserRouter>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/App/index.js
 **/